import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const ButtonLabel = styled.div<IWithSize>`
  font-family: 'Open Sans', sans-serif;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  width: 100%;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px; 
  text-align: center;
  color: #009139;
`
export default ButtonLabel
